<template>
  <WidgetCard title="Aggregated alerts" icon="pull-request" :loading="loading" :error="error">
    <div class="ce-w">
      <div class="ce-w__row">
        <div class="ce-w__cell">
          <div class="ce-w__n">1 · Alerts</div>
          <div class="ce-w__v">{{ formatNumber(summary.alerts) }}</div>
          <div class="ce-w__d">One for each changed page.</div>
        </div>
        <div class="ce-w__cell">
          <div class="ce-w__n">2 · Aggregated alerts</div>
          <div class="ce-w__v">{{ formatNumber(summary.events) }}</div>
          <div class="ce-w__d">{{ ratioText }}</div>
        </div>
        <div class="ce-w__cell ce-w__cell--inbox">
          <div class="ce-w__n">3 · Site-wide incidents</div>
          <div class="ce-w__v">{{ formatNumber(summary.site_incidents) }}</div>
          <div class="ce-w__d">On {{ formatNumber(summary.sites_affected) }} website{{ Number(summary.sites_affected) === 1 ? '' : 's' }}.</div>
        </div>
        <div class="ce-w__cell ce-w__cell--inbox">
          <div class="ce-w__n">4 · Messages</div>
          <div class="ce-w__v ce-w__v--pending">-</div>
          <div class="ce-w__d">Counted from the next phase.</div>
        </div>
      </div>
      <p class="ce-w__note">
        Boxes 1 and 2 make the dashboard shorter. Boxes 3 and 4 make the inbox quieter. They are separate.
      </p>
      <router-link class="ce-w__link" to="/change-events/overview">Open the Aggregated Alerts overview</router-link>
    </div>
  </WidgetCard>
</template>

<script>
  import WidgetCard from './WidgetCard.vue';
  import dashboardWidget from '../../mixins/dashboardWidget.mixin';
  import ChangeEventsService from '@modules/ChangeEvents/services/ChangeEvents.service';
  import { formatNumber, ratioLabel } from '@modules/ChangeEvents/consts/ChangeEvents.consts';

  export default {
    name: 'ChangeEventsSummaryWidget',
    components: { WidgetCard },
    mixins: [dashboardWidget],
    data() {
      return {
        summary: { alerts: 0, events: 0, ratio: 0, site_incidents: 0, sites_affected: 0 }
      };
    },
    computed: {
      ratioText() {
        const label = ratioLabel(this.summary.ratio);
        return label ? `${label} to read.` : 'Grouped by cause.';
      }
    },
    methods: {
      formatNumber,
      // The summary endpoint is account-wide and defaults to the last 7 days,
      // so this widget sends no filters.
      fetchResource() {
        return ChangeEventsService.fetchSummary();
      },
      applyResult(res) {
        this.summary = { ...this.summary, ...(res || {}) };
      }
    }
  };
</script>

<style lang="scss" scoped>
  .ce-w {
    display: flex;
    flex-direction: column;
    min-height: 0;
    flex: 1;

    &__row {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(110px, 1fr));
      gap: 8px;
    }
    &__cell {
      border: 1px solid #e3e7ea;
      border-radius: 6px;
      padding: 8px 10px;

      &--inbox {
        background: #fffdf6;
        border-color: #efe2b8;
      }
    }
    &__n {
      font-size: 10px;
      font-weight: 700;
      letter-spacing: 0.05em;
      text-transform: uppercase;
      color: #8a94a0;
    }
    &__v {
      font-size: 22px;
      font-weight: 700;
      line-height: 1.2;
      color: #232a31;

      &--pending {
        color: #8a94a0;
      }
    }
    &__d {
      font-size: 11px;
      color: #5b6570;
    }
    &__note {
      font-size: 11.5px;
      color: #5b6570;
      margin: 10px 0 0;
    }
    &__link {
      margin-top: auto;
      padding-top: 6px;
      font-size: 12px;
      color: #20a4b8;

      &:hover {
        text-decoration: underline;
      }
    }
  }
</style>
